import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IProfitAnalysisProps {
  revenueAnalysis: ReturnType<NplCalculation['getRevenueAnalysis']>;
}

const ItemRow = ({
  label,
  content,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
}) => (
  <s.Item>
    <s.ItemLabel>{label}</s.ItemLabel>
    <s.ItemContent>{content}</s.ItemContent>
  </s.Item>
);

const ProfitAnalysis = (props: IProfitAnalysisProps) => {
  const { revenueAnalysis } = props;
  return (
    <s.Div style={{ marginBottom: '0px' }}>
      <s.Title>수익분석</s.Title>
      <div>
        <ItemRow
          label="예상배당액"
          content={ReportFormatNumber(revenueAnalysis.row1)}
        />
        <ItemRow
          label="경매비용 환수금액"
          content={ReportFormatNumber(revenueAnalysis.row2)}
        />
      </div>
      <div>
        <s.Grid>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>A안</s.CellTitle>
            <s.CellContent>자기자본 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>B안</s.CellTitle>
            <s.CellContent>레버리지 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>총투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row3_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>총투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row3_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#FAFAFB">
            <s.CellTitle></s.CellTitle>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>질권대출 상환금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row4)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>예상 수익금액</s.CellTitle>
            <s.CellContent color="#008AFF">
              {ReportFormatNumber(revenueAnalysis.row5_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>예상 수익금액</s.CellTitle>
            <s.CellContent color="#008AFF">
              {ReportFormatNumber(revenueAnalysis.row5_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>
              총투자비용 대비
              <br />
              예상수익률
            </s.CellTitle>
            <s.CellContent color="#008AFF">
              {ReportFormatNumber(revenueAnalysis.row6_1, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>
              총투자비용 대비
              <br />
              예상수익률
            </s.CellTitle>
            <s.CellContent color="#008AFF">
              {ReportFormatNumber(revenueAnalysis.row6_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>예상수익률(年利)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row7_1, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>예상수익률(年利)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(revenueAnalysis.row7_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
        </s.Grid>
        <s.Description style={{ marginTop: '8px' }}>
          <img
            src="/assets/images/icon/info_16.svg"
            alt=""
            style={{ width: 16 }}
          />
          <span>
            예상수익률은 예상배당액 및 총투자비용에 따라 변동될 수 있습니다.
          </span>
        </s.Description>
      </div>
    </s.Div>
  );
};

export default ProfitAnalysis;
